import DisableElements from "./js/DisableElements";
export default DisableElements;